module.exports = __webpack_public_path__ + "assets/img/ourservice01-cn.2596bb0e.png";